import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const captionSchema: CollectionCreateSchema = {
  name: CollectionName.Caption,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "field_unique_id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "text_en",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "text_translations",
      type: "object[]",
      optional: true,
    },
    {
      name: "created_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "created_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
